var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedinSimple(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.869364 7.00042H5.27455V20.2363H0.869364V7.00042Z",
    fill: "#0077B5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.10107 0.619873C4.60813 0.619873 5.53616 1.60832 5.56475 2.90609C5.56475 4.17697 4.60813 5.19385 3.07208 5.19385H3.04389C1.56502 5.19385 0.608887 4.17697 0.608887 2.90609C0.608887 1.60832 1.5941 0.619873 3.10107 0.619873Z",
    fill: "#0077B5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0894 6.68965C18.9882 6.68965 21.1615 8.58183 21.1615 12.6473L21.1613 20.2363H16.7563V13.1551C16.7563 11.3765 16.1188 10.1628 14.5241 10.1628C13.3071 10.1628 12.5822 10.981 12.2638 11.7713C12.1473 12.0545 12.1187 12.4491 12.1187 12.8446V20.2366H7.71296C7.71296 20.2366 7.77103 8.24279 7.71296 7.00083H12.1187V8.87552C12.7033 7.9743 13.7505 6.68965 16.0894 6.68965Z",
    fill: "#0077B5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinSimple);
export default __webpack_public_path__ + "static/media/linkedin_simple.d22c1c92.svg";
export { ForwardRef as ReactComponent };